import { logger } from '../../../../utils/common/logger'
import { LoginService } from '../loginradius/services/login-service'

export class OnboardExclusiveNewsletter {
    public static DOM = {
        attrs: {
            continueButton: 'data-onboard-continue'
        },
        class: {
            pageOnboardExclusiveNewsletter: 'page-onboard-exclusive-newsletter',
        },
    }

    public init() {
        const onboardExclusiveNewsletterPage = document.querySelector
            (`.${OnboardExclusiveNewsletter.DOM.class.pageOnboardExclusiveNewsletter}`)

        if (onboardExclusiveNewsletterPage) {
            const continueButton = document.querySelector(
                `[${OnboardExclusiveNewsletter.DOM.attrs.continueButton}]`
            ) as HTMLButtonElement

            const redirect = LoginService.getRedirectUrl(location.origin)
            if (continueButton) {
                continueButton.addEventListener('click', () => {
                    logger('info', 'Onboard exclusive newsletter continue - redirecting')
                    location.replace(redirect)
                })
            }
        }
    }
}
